// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as LoginComponent} from './Login.svg';

import Icon, { TIconProps } from '../Icon';

export const IconLogin = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <LoginComponent/>
  </Icon>
));
